import { useState } from "react";
import DynamicFilterBar from "../../../common/AdminCommonComponents/FilterBars/DynamicFilterBar/DynamicFilterBar";
import AllOrders from "./AllOrders/AllOrders";

const Orders = () => {

  const tabs = [
    { key: 'allOrders', label: 'All Orders' }, 
    // { key: 'orderCoordination', label: "Order Coordination" }, 
  ]
  const [activeTab, setActiveTab] = useState(tabs[0].key)

  return (
    <div>
      <div className="bg-white p-3 shadow">
        <DynamicFilterBar filterTabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} barType="orange-sub-bar" />

      </div>
      
      {activeTab === 'allOrders' && <AllOrders />}


    </div>
  );
};

export default Orders;